import PropTypes from "prop-types";
import React from "react";
import { Button, Modal } from "react-bootstrap";

class DialogModal extends React.Component {
  static get propTypes() {
    return {
      title: PropTypes.node,
      btnStyle: PropTypes.string,
      desc: PropTypes.node,
      onHide: PropTypes.func,
      onSuccess: PropTypes.func,
      buttonLabel: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      title: "Are you sure?",
      btnStyle: "primary",
    };
  }

  render() {
    const { btnStyle, buttonLabel, desc, onHide, onSuccess, title } =
      this.props;

    return (
      <Modal className="dialog-modal" show={true} onHide={onHide}>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{desc}</Modal.Body>
        <Modal.Footer>
          <Button onClick={onHide} variant="secondary">Close</Button>
          {onSuccess ? (
            <Button onClick={onSuccess} variant={btnStyle}>
              {buttonLabel}
            </Button>
          ) : null}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DialogModal;
export { DialogModal };
